<form #formRef sc-form [formGroup]="form" [ngSwitch]="product" [class.slidemode]="currentView !== undefined" novalidate (ngSubmit)="submit()">
    <div class="group step1" [class.hidden]="hiddenElements.includes('zip') || (currentView !== undefined && currentView !== viewTypes.ZIPCODE)">
        <article *ngIf="currentView !== undefined">Do obliczenia i przedstawienia tylko tych ofert które są dostępne w Twoim regionie, potrzebny jest kod pocztowy. Wpisz go ponizej.</article>
        <label [class.shake]="submitted && form.get('zip').invalid" #zipLabel>Podaj kod pocztowy</label>
        <sc-error [class.hidden]="!submitted" #errorZipcodeRef></sc-error>
        <sc-input formControlName="zip" placeholder="00-000" mask="00-000" inputmode="numeric" maxlength="6" [labelRef]="zipLabel" (onupdate)="onInputChanged($event)" [errorRef]="errorZipcodeRef" [customErrors]="errorsZip"></sc-input>
        <article *ngIf="currentView !== undefined">Następnie, użyj poniższy przycisk aby przejść dalej.</article>
    </div>

    <div class="group step2" [class.hidden]="hiddenElements.includes('choise') || (currentView !== undefined && currentView !== viewTypes.CHOISE)" *ngIf="product !== 'fotowoltaika' else greenEnergy">
        <article *ngIf="currentView !== undefined">
          Obliczymy dla Ciebie ile możesz zaoszczędzić, porównując Twojego obecnego dostawcę do stawek konkurencji.<br />
          Wybierz z poniższej listy swojego obecnego dostawcę 
          <ng-container *ngSwitchCase="'prad'">energii elektrycznej.</ng-container>
          <ng-container *ngSwitchCase="'gaz'">gazu.</ng-container>
        </article>
        <label [class.shake]="submitted && form.get('choise').invalid" #provLabel>
            {{ !small ? 'Kto jest twoim obecnym dostawcą' : 'Twój obecnym dostawca' }}
            <ng-container *ngSwitchCase="'prad'">energii</ng-container>
            <ng-container *ngSwitchCase="'gaz'">gazu</ng-container>
        ?</label>
        <sc-error [class.hidden]="!submitted" #errorProviderRef></sc-error>
        <div class="radios sellers" [class.small]="small">
            <ng-container *ngSwitchCase="'gaz'">
                <sc-checkbox type="radio" val="pgnig" group="choise" formControlName="choise" theme="box" [labelRef]="provLabel" [errorRef]="errorProviderRef" (onupdate)="onInputChanged($event)" [customErrors]="errorsEnergy"></sc-checkbox>
                <sc-checkbox type="radio" val="tauron-gaz" group="choise" formControlName="choise" theme="box" [labelRef]="provLabel" [errorRef]="errorProviderRef" (onupdate)="onInputChanged($event)" [customErrors]="errorsEnergy"></sc-checkbox>
                <sc-checkbox type="radio" val="energa-gaz" group="choise" formControlName="choise" theme="box" [labelRef]="provLabel" [errorRef]="errorProviderRef" (onupdate)="onInputChanged($event)" [customErrors]="errorsEnergy"></sc-checkbox>
                <sc-checkbox type="radio" val="enea-gaz" group="choise" formControlName="choise" theme="box" [labelRef]="provLabel" [errorRef]="errorProviderRef" (onupdate)="onInputChanged($event)" [customErrors]="errorsEnergy"></sc-checkbox>
                <sc-checkbox type="radio" val="axpo-gaz" group="choise" formControlName="choise" theme="box" [labelRef]="provLabel" [errorRef]="errorProviderRef" (onupdate)="onInputChanged($event)" [customErrors]="errorsEnergy"></sc-checkbox>
                <sc-checkbox type="radio" val="handen-gaz" group="choise" formControlName="choise" theme="box" [labelRef]="provLabel" [errorRef]="errorProviderRef" (onupdate)="onInputChanged($event)" [customErrors]="errorsEnergy"></sc-checkbox>
                <sc-checkbox type="radio" val="innogy-gaz" group="choise" formControlName="choise" theme="box" [labelRef]="provLabel" [errorRef]="errorProviderRef" (onupdate)="onInputChanged($event)" [customErrors]="errorsEnergy"></sc-checkbox>
                <sc-checkbox type="radio" val="other" group="choise" formControlName="choise" theme="box" [errorRef]="errorProviderRef" (onupdate)="onInputChanged($event)" [customErrors]="errorsEnergy"></sc-checkbox>
            </ng-container>
            <ng-container *ngSwitchCase="'prad'">
                <sc-checkbox type="radio" val="pge" group="choise" formControlName="choise" theme="box" [labelRef]="provLabel" [errorRef]="errorProviderRef" (onupdate)="onInputChanged($event)" [customErrors]="errorsEnergy"></sc-checkbox>
                <sc-checkbox type="radio" val="tauron" group="choise" formControlName="choise" theme="box" [labelRef]="provLabel" [errorRef]="errorProviderRef" (onupdate)="onInputChanged($event)" [customErrors]="errorsEnergy"></sc-checkbox>
                <sc-checkbox type="radio" val="energa" group="choise" formControlName="choise" theme="box" [labelRef]="provLabel" [errorRef]="errorProviderRef" (onupdate)="onInputChanged($event)" [customErrors]="errorsEnergy"></sc-checkbox>
                <sc-checkbox type="radio" val="enea" group="choise" formControlName="choise" theme="box" [labelRef]="provLabel" [errorRef]="errorProviderRef" (onupdate)="onInputChanged($event)" [customErrors]="errorsEnergy"></sc-checkbox>
                <sc-checkbox type="radio" val="axpo" group="choise" formControlName="choise" theme="box" [labelRef]="provLabel" [errorRef]="errorProviderRef" (onupdate)="onInputChanged($event)" [customErrors]="errorsEnergy"></sc-checkbox>
                <sc-checkbox type="radio" val="handen" group="choise" formControlName="choise" theme="box" [labelRef]="provLabel" [errorRef]="errorProviderRef" (onupdate)="onInputChanged($event)" [customErrors]="errorsEnergy"></sc-checkbox>
                <sc-checkbox type="radio" val="innogy" group="choise" formControlName="choise" theme="box" [labelRef]="provLabel" [errorRef]="errorProviderRef" (onupdate)="onInputChanged($event)" [customErrors]="errorsEnergy"></sc-checkbox>
                <sc-checkbox type="radio" val="other" group="choise" formControlName="choise" theme="box" [errorRef]="errorProviderRef" (onupdate)="onInputChanged($event)" [customErrors]="errorsEnergy"></sc-checkbox>
            </ng-container>
        </div>
        <article *ngIf="currentView !== undefined">Następnie, użyj poniższy przycisk aby przejść dalej.</article>
    </div>
    <ng-template #greenEnergy>
        <div class="group step2" [class.hidden]="hiddenElements.includes('choise') || (currentView !== undefined && currentView !== viewTypes.CHOISE)">
            <article *ngIf="currentView !== undefined">W celu dobrania odpowiednich komponentów, określ powierzchnę którą chcesz przeznaczyć do instalacji paneli fotowoltaicznych.</article>
            <label [class.shake]="submitted && form.get('choise').invalid" #provLabel>Wybierz miejsce montażu<sup *ngIf="currentView">*</sup></label>
            <sc-error [class.hidden]="!submitted" #errorProviderRef></sc-error>
            <div class="radios roofs">
                <sc-checkbox *ngFor="let roof of roofs" type="radio" [val]="roof.id" [attr.data-type]="roof.id" [class.hidden]="roof.hidden && !showMore" [attr.data-title]="roof.label" group="choise" formControlName="choise" theme="box" [labelRef]="provLabel" [errorRef]="errorProviderRef" (onupdate)="onInputChanged($event)" (mouseenter)="onInputMouseEnter($event)" (mouseleave)="onInputMouseLeave($event)" [customErrors]="errorsSolars"></sc-checkbox>
                <button type="button" class="more" (click)="showMore = !showMore">{{ showMore ? 'mniej' : 'więcej' }}</button>
                <sc-checkbox [class.hidden]="!showMore" data-title="Inny" type="radio" val="other" group="choise" formControlName="choise" theme="box" [errorRef]="errorProviderRef" (onupdate)="onInputChanged($event)" (mouseenter)="onInputMouseEnter($event)" (mouseleave)="onInputMouseLeave($event)" [customErrors]="errorsSolars"></sc-checkbox>
            </div>
            <div class="choise-name" [class.mmt]="currentView !== undefined" [class.empty]="!choisePreview">{{ choisePreview }}</div>
            <article *ngIf="currentView !== undefined" [class.empty]="choisePreview"><sup>*</sup>Kliknij na powyższe ikonki by wyświetlić opis powierzchni.</article>
        </div>
    </ng-template>

    <ng-container *ngIf="type === 0 || currentView === viewTypes.AMOUNT">
      <div class="group last" [class.hidden]="hiddenElements.includes('value') || (currentView !== undefined && currentView !== viewTypes.AMOUNT)" *ngSwitchCase="'prad'">
          <label #valLabel>Jakie jest Twoje roczne zużycie?</label>
          <article *ngIf="currentView !== undefined">
            Ta informacja potrzebna jest do oszacowania przedziału cenowego ofert.<br />
            W następnym kroku, będzie można zmienić tę wartość, podobnie jak taryfę oraz wiele innych filtrów.
          </article>
          <sc-range-slider formControlName="value" sufix="MWh/rok" prefix="około" [min]="5" [max]="400" (onupdate)="onInputChanged($event)"></sc-range-slider>
          <article *ngIf="currentView !== undefined">
            Następnie, użyj poniższy przycisk aby wyświetlić listę ofert.
          </article>
      </div>
      <div class="group last" [class.hidden]="hiddenElements.includes('value') || (currentView !== undefined && currentView !== viewTypes.AMOUNT)" *ngSwitchCase="'gaz'">
          <label #valLabel>Jakie jest Twoje roczne zużycie?</label>
          <article *ngIf="currentView !== undefined">
            Ta informacja potrzebna jest do oszacowania przedziału cenowego ofert.<br />
            W następnym kroku, będzie można zmienić tę wartość, podobnie jak taryfę oraz wiele innych filtrów.
          </article>
          <sc-range-slider formControlName="value" sufix="MWh/rok" prefix="około" [min]="5" [max]="400" (onupdate)="onInputChanged($event)"></sc-range-slider>
          <article *ngIf="currentView !== undefined">
            Następnie, użyj poniższy przycisk aby wyświetlić listę ofert.
          </article>
      </div>
      <div class="group last" [class.hidden]="hiddenElements.includes('value') || (currentView !== undefined && currentView !== viewTypes.AMOUNT)" *ngSwitchCase="'fotowoltaika'">
          <label #valLabel>Ile płacisz rocznie za prąd?</label>
          <article *ngIf="currentView !== undefined">
            Ta informacja potrzebna jest do oszacowania wielkości instalacji fotowoltaicznej, która będzie dla Ciebie najbardziej optymalna.<br />
            W następnym kroku, będzie można zmienić tę wartość, podająć dokładną wielkość instalacji w KW lub zmieniając kwotę miesięcznego rachunku za energię.
          </article>
          <sc-range-slider formControlName="value" sufix="zł/rok" prefix="około" [min]="1000" [max]="10000" (onupdate)="onInputChanged($event)"></sc-range-slider>
          <article *ngIf="currentView !== undefined">
            Następnie, użyj poniższy przycisk aby wyświetlić listę ofert.
          </article>
      </div>
    </ng-container>

    <div class="group terms" [class.hidden]="hiddenElements.includes('term') || (currentView !== undefined && currentView !== viewTypes.TERM)" *ngIf="!disableTerms">
        <article *ngIf="currentView !== undefined">
          Pozostało tylko wyrażenie zgody na przedsawienie oferty.<br />
          Tylko wtedy będziemy mogli przedstawić Ci aktualne ceny.
        </article>
        <sc-checkbox [class.small]="small" [class.shake]="submitted && form.get('term').invalid"  formControlName="term" [errorRef]="errorTermRef">
            <div class="label" [class.open]="termFullView">
                <ng-container *ngIf="!termFullView else showFullTerm">
                    <span>Zapoznał(a)em się z <a [href]="legal.regulamin" target="_blank" rel="noopener noreferrer" title="Regulamin świadczenia usług">regulaminem</a></span><span class="nobr"> i akceptuję go</span>.
                </ng-container>
                <ng-template #showFullTerm>
                    Chcę otrzymać porównanie ofert dostawców prądu, gazu oraz zajmujących się fotowoltaiką.
                    Zapoznałem się z <a [href]="legal.regulamin" target="_blank" rel="noopener noreferrer" title="Regulamin świadczenia usług">Regulaminem świadczenia usług</a> i go akceptuję.
                    Administratorem Twoich danych jest Eko Mocni sp. z o.o. z siedzibą w Warszawie.
                    Szczegółowe informacje znajdziesz w <a [href]="legal.polityka" target="_blank" rel="noopener noreferrer" title="Polityka Prywatności">Polityce Prywatności</a>
                </ng-template>
            </div>
            <div class="term-arrow" [class.open]="termFullView" (click)="termFullView = !termFullView"></div>
            <sc-error [class.open]="termFullView" [class.hidden]="!submitted" #errorTermRef></sc-error>
        </sc-checkbox>
        <article *ngIf="currentView !== undefined"></article>
    </div>
    
    <button sc-button type="submit" [class.last]="currentView !== undefined && currentView === viewTypes.TERM" [ngSwitch]="currentView">
        <ng-container *ngSwitchCase="viewTypes.ZIPCODE">
            <span>Dalej</span>
            <i><ng-container [ngTemplateOutlet]="iconArr"></ng-container></i>
        </ng-container>
        <ng-container *ngSwitchCase="viewTypes.CHOISE">
            <span>Dalej</span>
            <i><ng-container [ngTemplateOutlet]="iconArr"></ng-container></i>
        </ng-container>
        <ng-container *ngSwitchCase="viewTypes.AMOUNT">
            <span>Pokaż wyceny</span>
            <i><ng-container [ngTemplateOutlet]="iconArr"></ng-container></i>
        </ng-container>
        <ng-container *ngSwitchCase="viewTypes.TERM">
            <span>Pokaż wyceny</span>
            <i><ng-container [ngTemplateOutlet]="iconDone"></ng-container></i>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <span>{{ buttonTextMessage }}</span>
            <i><ng-container [ngTemplateOutlet]="iconArr"></ng-container></i>
        </ng-container>
    </button>

</form>

<ng-template #iconArr>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns:svgjs="http://svgjs.com/svgjs"
      version="1.1"
      width="23"
      height="22"
      x="0"
      y="0"
      viewBox="0 0 511.993 511.993"
      style="enable-background:new 0 0 23 22"
      xml:space="preserve"
    >
      <g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="M487.292,235.408H20.59c-11.372,0-20.59,9.224-20.59,20.59c0,11.366,9.217,20.59,20.59,20.59h466.702    c11.372,0,20.59-9.217,20.59-20.59C507.882,244.625,498.665,235.408,487.292,235.408z"
              fill="#ffffff"
              data-original="#000000"
              style=""
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="M505.96,241.434L304.187,39.653c-8.044-8.037-21.07-8.037-29.114,0c-8.044,8.044-8.044,21.084,0,29.121l187.216,187.223    L275.073,443.221c-8.044,8.037-8.044,21.077,0,29.114c4.022,4.022,9.286,6.033,14.557,6.033s10.535-2.011,14.557-6.033    l201.773-201.78C514.004,262.511,514.004,249.47,505.96,241.434z"
              fill="#ffffff"
              data-original="#000000"
              style=""
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
      </g>
    </svg>
  </ng-template>
  
  <ng-template #iconDone>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns:svgjs="http://svgjs.com/svgjs"
      version="1.1"
      width="23"
      height="23"
      x="0"
      y="0"
      viewBox="0 0 375.147 375.147"
      style="enable-background:new 0 0 23 23"
      xml:space="preserve"
    >
      <g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <polygon
              points="344.96,44.48 119.147,270.293 30.187,181.333 0,211.52 119.147,330.667 375.147,74.667   "
              fill="#ffffff"
              data-original="#000000"
              style=""
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
      </g>
    </svg>
  </ng-template>